const imageRemoteUrlObj = {
  Nike: `${process.env.ASSETS_BASE_URL}/pay/customer-page/merchant/nike.webp`,
  Adidas: `${process.env.ASSETS_BASE_URL}/pay/customer-page/merchant/adidas.webp`,
  Apple: `${process.env.ASSETS_BASE_URL}/pay/customer-page/merchant/apple.webp`,
  Starbucks: `${process.env.ASSETS_BASE_URL}/pay/customer-page/merchant/starbucks.webp`,
  Ledger: `${process.env.ASSETS_BASE_URL}/pay/customer-page/merchant/ledger.webp`,
  AppleGiftCard: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/apple-giftcard.webp`,
  AdidasGiftCard: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/adidas-giftcard.webp`,
  StarbucksGiftCard: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/starbucks-giftcard.webp`,
  ColumnbiaGiftCard: `${process.env.ASSETS_BASE_URL}/pay/customer-page/giftcard/columbia-giftcard.webp`,
}

export const useMerchantCardData = () => {
  const {
    Nike,
    Adidas,
    Apple,
    Starbucks,
    Ledger,
    AppleGiftCard,
    AdidasGiftCard,
    StarbucksGiftCard,
    ColumnbiaGiftCard,
  } = imageRemoteUrlObj
  return {
    nike: {
      imageSrc: Nike,
      width: ["100%", 356, 441],
      height: [288, 232, 360],
    },
    apple: {
      imageSrc: Apple,
      width: ["100%", 232, 349],
      height: [232, 232, 360],
    },
    adidas: {
      imageSrc: Adidas,
      width: ["100%", 232, 349],
      height: [232, 232, 248],
    },
    starbucks: {
      imageSrc: Starbucks,
      width: ["100%", 356, 349],
      height: [232, 232, 248],
    },
    ledger: {
      imageSrc: Ledger,
      width: ["100%", 232, 349],
      height: [232, 232, 248],
    },
    appleGiftCard: {
      imageSrc: AppleGiftCard,
      width: [222, 409, 532],
      height: [143, 232, 300],
    },
    starbucksGiftCard: {
      imageSrc: StarbucksGiftCard,
      width: [222, 409, 532],
      height: [143, 232, 300],
    },
    adidasGiftCard: {
      imageSrc: AdidasGiftCard,
      width: [222, 409, 532],
      height: [143, 232, 300],
    },
    columbiaGiftCard: {
      imageSrc: ColumnbiaGiftCard,
      width: [222, 409, 532],
      height: [143, 232, 300],
    },
  }
}
